export default __webpack_public_path__ + "static/media/Darkslayer Bracers.b14ba85d.jpg";